import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { SlideInterfaceModel } from '../../../models/slide.model';

@Component({
  selector: 'app-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.scss'],
  standalone: false,
})
export class ImageSliderComponent implements AfterViewInit, OnDestroy {
  @Input() slides: SlideInterfaceModel[] = [];
  @Input() isLoading: boolean = true;
  @Input() showButtons: boolean = true;

  private currentIndex: number = 0;
  private timeoutId?: number;

  @ViewChild('scrl') scrl: ElementRef | undefined;

  private scrollX = 0;
  private scrollEnd = false;

  public ngAfterViewInit(): void {
    this.resetTimer();
  }
  public ngOnDestroy() {
    window.clearTimeout(this.timeoutId);
  }
  private resetTimer() {
    if (this.timeoutId) {
      window.clearTimeout(this.timeoutId);
    }
    this.timeoutId = window.setTimeout(() => this.slide(1236), 5000);
  }

  public goToSlide(slideIndex: number): void {
    const slideStep = this.scrl.nativeElement.scrollWidth / this.slides.length;
    const shift = slideStep * slideIndex;
    this.scrl.nativeElement.scrollLeft = shift;
    this.scrollX += shift;
    this.resetTimer();
    this.scrollCheck();
    this.currentIndex = slideIndex;
  }

  public dotActive(index: number): boolean {
    return this.currentIndex === index;
  }

  public slide(shift: number) {
    if (this.scrl) {
      this.scrl.nativeElement.scrollBy({
        left: shift,
        behavior: 'smooth',
      });
      if (this.scrollX <= 4 && shift === -1236) {
        shift += this.scrl.nativeElement.scrollWidth;
        this.currentIndex = this.slides.length - 1;
      } else if (this.scrollEnd && shift === 1236) {
        shift -= this.scrl.nativeElement.scrollWidth;
        this.currentIndex = 0;
      } else {
        if (shift < 0) {
          this.currentIndex--;
        } else {
          this.currentIndex++;
        }
      }
      this.scrl.nativeElement.scrollLeft += shift;
      this.scrollX += shift;

      this.resetTimer();
      this.scrollCheck();
    }
  }

  public scrollCheck() {
    if (this.scrl) {
      this.scrollX = this.scrl.nativeElement.scrollLeft;
      this.scrollEnd =
        Math.floor(
          this.scrl.nativeElement.scrollWidth -
            this.scrl.nativeElement.scrollLeft
        ) <=
        this.scrl.nativeElement.offsetWidth + 4;
    }
  }
}
